import title from "../../images/integration/Metrics.png";
import Parameters from "shared/components/Parameters";
import Layout from "../../components/Layout";
import { MinDigitsBrand } from "shared/components/MinDigitsBrand";


export function Page() {

  return (
    <Layout >
      <div className="container">
        <div className="article-container">
          <div className="d-flex justify-content-between flex-wrap">
            <h1 className="mb-4 ">
              Интеллектуальная система учета (SCADA NPT Compact)
            </h1>
            <MinDigitsBrand id="309051" />
          </div>

          <Parameters
            title=" "
            image={title}
            // images={images}
            zoomColor="white"
          >
            <p>
              <b>Интеллектуальная система учета электроэнергии</b> представляет собой современный подход к сбору, обработке и анализу данных об энергопотреблении. Она использует интеллектуальные счетчики (smart meters), коммуникационные сети и программное обеспечение <b>SCADA NPT Compact</b> для предоставления расширенных возможностей по сравнению с традиционными системами учета.
            </p>

            <p>Функции системы:</p>
            <ul className="mb-4 description__list">

              <li className="mb-1 description__number-li"><b>Автоматический сбор данных</b>
                <ul>
                  <li>Интеллектуальные счетчики автоматически собирают данные о потреблении электроэнергии в реальном времени.
                  </li>
                  <li>Данные со счетчиков собираются в <b>SCADA NPT Compact</b> без необходимости ручного снятия показаний.</li>
                </ul>
              </li>
              <li className="mb-1 description__number-li"><b>Мониторинг в реальном времени</b>
                <ul>
                  <li>С помощью интерфейса <b>SCADA NPT Compact</b> потребители и энергокомпании могут отслеживать потребление электроэнергии в режиме реального времени.
                  </li>
                </ul>
              </li>
              <li className="mb-1 description__number-li"><b>Подробный учет и тарификация</b>
                <ul>
                  <li> <b>SCADA NPT Compact</b> в соответствии с возможностями счетчиков обеспечивает подробный учет потребления энергии, что позволяет применять гибкие тарифы (например, дифференцированные по времени суток).
                  </li>
                  <li>
                    Потребители могут оптимизировать свои расходы, используя энергию в периоды с более низкими тарифами.
                  </li>
                </ul>
              </li>
              <li className="mb-1 description__number-li"><b>Аналитика и прогнозирование</b>
                <ul>
                  <li> <b>SCADA NPT Compact</b> формирует отчеты для энергокомпаний, регуляторов и потребителей.
                  </li>
                  <li>
                    Пользователи системы могут анализировать свои данные для выявления возможностей снижения энергопотребления.
                  </li>
                  <li> <b>SCADA NPT Compact</b>  использует алгоритмы анализа данных для прогнозирования потребления энергии.</li>
                  <li>Система предоставляет рекомендации по повышению энергоэффективности.</li>
                </ul>
              </li>
              <li className="mb-1 description__number-li"><b>Интеграция с другими системами</b>
                <ul>
                  <li>Данная система может быть расширена за счет интеграции с системами автоматизации (EMS) и IoT-устройствами для создания единой экосистемы для управления энергопотреблением.</li>
                </ul>
              </li>

            </ul>
            <a className="text-links" href="https://epsa-spb.ru/kontakty-2/">Запросить референс лист</a>

          </Parameters>
        </div>
      </div>
    </Layout>

  );
}

